import {
  http,
  delay,
  HttpResponse,
} from 'msw';

import { createCsvMockEndpoint } from '@/mocks/create-csv-mock-endpoint';
import { createMockEndpoint } from '@/mocks/create-mock-endpoint';
import { CampaignCompanyDownloadResponse } from '@/repositories/generated';

const response: CampaignCompanyDownloadResponse = {
  presignedUrl: createCsvMockEndpoint([
    ['企業ID', '企業名'],
    ['00001', '企業1'],
  ]),
};

export const campaignCompanyDownload = http.get(
  createMockEndpoint('/campaign/:id/download/company'),
  async () => {
    await delay(500);
    return HttpResponse.json(response, { status: 200 });
  },
);
